import { Component, Inject, Renderer2, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

import { List } from '../../shared/list';

import { QuotaItem, QuotaFilter } from '../../_models/quota-item';
import { MapQuotaService } from '../../_services/map-quota.service';
import { QuotaService } from '../../_services/quota.service';
import { QuotaAggregateService } from '../../_services/quota-aggregate.service';

import { NotificationsService } from '../../_services/notifications.service';
import { Zone } from '../../_models/zone';
import { ZoneService } from '../../_services/zone.service';
import { Profile } from '../../_models/profile';
import { Ship } from '../../_models/ship';
import { StockMinimal } from '../../_models/stock-minimal';

@Component({
  selector: 'app-map-quota',
  templateUrl: './maps_quotas.component.html',
})
export class MapQuotaComponent extends List implements OnInit {
  public currentYear = new Date().getFullYear();
  public profile: Profile;
  errorMessage: string;
  filter: QuotaFilter;
  zones: Zone[] = [];
  selectedZones: Zone[];
  google_url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDjCqNgr4eRjBSEMZ6J6Mscgc6h4hJIRVk';
  htmlText: string;
  zone_selected: string;
  form: FormGroup;
  selectedShips: Ship[] = [];
  selectedStock: StockMinimal;
  years: string[] = [];

  constructor(
    private fb: FormBuilder,
    private mapQuotaService: MapQuotaService,
    private renderer: Renderer2,
    private zoneService: ZoneService,
    private quotaService: QuotaService,
    private quotaAgregatedService: QuotaAggregateService,
    private router: Router,
    private route: ActivatedRoute,
    protected notificationsService: NotificationsService,

    @Inject(DOCUMENT) private document: Document,
    private renderer2: Renderer2
  ) {
    super(mapQuotaService, new QuotaItem(), router, route);
    this.years = Zone.getYears();
    this.form = fb.group({
      ship: [''],
      stock: [''],
      year: [''],
    });
  }

  ngOnInit() {
    this.getZones();
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.filter = new QuotaFilter();
  }

  getZones() {
    this.zoneService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.zones = response.results;
        this.initMap();
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  private initMap() {
    const map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
      zoom: 3,
      center: { lat: 60.182203, lng: -18.986541 },
      mapTypeId: 'terrain',
      gestureHandling: 'greedy',
    });

    for (const my_zone of this.zones) {
      const coord_polygon = [];
      if (my_zone.polygon !== '' && my_zone.polygon !== null) {
        const coord_array = my_zone.polygon.split(',');
        let last_coord = {};
        for (const my_coord of coord_array) {
          const coordinates = my_coord.split(' ');
          if (coordinates[0] !== '') {
            last_coord = { lat: parseFloat(coordinates[1]), lng: parseFloat(coordinates[0]) };
            coord_polygon.push(last_coord);
          }
        }
        // Construct the polygon.
        const polygon = new google.maps.Polygon({
          paths: coord_polygon,
          strokeColor: '#000',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#000',
          fillOpacity: 0.35,
        });
        let stock_list = '';
        let div = '';
        for (const my_stock of my_zone.zones) {
          div = '<div>' + my_stock.name + '</div>';
          stock_list = stock_list + div;
        }
        const contentString =
          '<div id="content"><h6 class="text-center">Zona: ' + my_zone.name + '</h6><div id="bodyContent">' + stock_list + '</div></div>';
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
        });
        polygon.setMap(map);
        const that = this;
        google.maps.event.addListener(polygon, 'click', function (event) {
          infowindow.setPosition(new google.maps.LatLng(last_coord['lat'], last_coord['lng']));
          infowindow.open(map, polygon);
          that.loadQuotas(my_zone);
        });
        google.maps.event.addListener(polygon, 'mouseover', function () {
          this.setOptions({ fillColor: '#2980BA' });
        });
        google.maps.event.addListener(polygon, 'mouseout', function () {
          this.setOptions({ fillColor: '#000' });
        });
      }
    }
  }

  public loadQuotas(my_zone) {
    this.zone_selected = '<b>' + my_zone.name + '</b>';
    this.htmlText = '';
    for (const my_stock of my_zone.zones) {
      this.filter.stock = [my_stock];
      this.getQuotas(my_stock.id);
    }
  }

  getQuotas(stock_id) {
    const params_string = { year: this.currentYear, stock: stock_id, ships: '' };
    const serialize_params = this.filter.serializeQueryParams(params_string);
    this.quotaAgregatedService.list(1, 10000, serialize_params, '').subscribe(
      (response) => {
        for (const record of response.results) {
          this.htmlText =
            this.htmlText +
            '<div class="card_stocks">' +
            '<div class="col-xs-12 header_card_stock"><span>Stock: ' +
            record.stock__name +
            '</span></div>' +
            '<div class="col-xs-12 body_card_stock"><span>Cuota Total: ' +
            record.amount +
            '</span><br>' +
            '<span>Cuota Consumida: ' +
            record.consumed +
            '</span><br>' +
            '<span>Cuota Pendiente: ' +
            record.pending +
            '</span></div>' +
            '</div></div>';
        }
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/maps/maps_quotas/maps_quotas.component.ts